'user client';

import { FC } from 'react';
import { ButtonGroup, Button } from '@/_components';

export const HelpCenter: FC<{ isAdvisor: boolean }> = ({ isAdvisor }) => {
  const helpCenterLink = isAdvisor
    ? 'https://helpcenter.soraban.com/'
    : '/help';

  const onNavigate = () => {
    window.open(helpCenterLink, '_blank');
  };

  return (
    <ButtonGroup>
      <Button
        intent="ghost"
        size="small"
        value="Help Center"
        isIconOnly={true}
        iconLeft="question"
        withTooltip
        tooltipPlacement="bottom"
        onClick={onNavigate}
      />
    </ButtonGroup>
  );
};
